import { render, staticRenderFns } from "./ShowPlaceComponent.vue?vue&type=template&id=f58ce5c8"
import script from "./ShowPlaceComponent.vue?vue&type=script&lang=js"
export * from "./ShowPlaceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports